/*eslint-disable */
import React, { useState, useEffect } from "react";
import {
    Modal,
} from "semantic-ui-react";
import OwnVehiclePlanning from './PlanningModal/ownVehiclePlanning'
import MarketVehiclePlanning from './PlanningModal/marketVehiclePlanning'

const ModalPlanningDetails = ({
    modalOpen,
    handleClose,
    auth,
    ...props
}) => {
    const [vehicleTypeSelected, setVehicleTypeSelected] = useState('ownVehicle');

    useEffect(() => {
    }, []);

    let changeTab = (e) => {
        let type = e.target.name;
        if (type == 'ownVehicle') {
            document.getElementById('ownVehicle-tab').classList.remove('w3-white', 'w3-round', 'w3-hover-white')
            document.getElementById('ownVehicle-tab').classList.add('w3-blue', 'w3-round', 'w3-hover-blue')
            document.getElementById('marketVehicle-tab').classList.remove('w3-blue', 'w3-round', 'w3-hover-blue')
            document.getElementById('marketVehicle-tab').classList.add('w3-white', 'w3-round', 'w3-hover-white')
            setVehicleTypeSelected('ownVehicle')
        } else {
            document.getElementById('ownVehicle-tab').classList.remove('w3-blue', 'w3-round', 'w3-hover-blue')
            document.getElementById('ownVehicle-tab').classList.add('w3-white', 'w3-round', 'w3-hover-white')
            document.getElementById('marketVehicle-tab').classList.remove('w3-white', 'w3-round', 'w3-hover-white')
            document.getElementById('marketVehicle-tab').classList.add('w3-blue', 'w3-round', 'w3-hover-blue')
            setVehicleTypeSelected('marketVehicle')
        }
    }


    return (
        <div>
            <Modal open={modalOpen} onClose={handleClose} size="fullscreen">
                <Modal.Header className="p-bold-100">
                    <div className="d-flex justify-content-between">
                    <h2 className="page-title">{"Planning"}</h2>
                        <div className="form-inline">
                            <i onClick={handleClose} className="fas fa-times"></i>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Content scrolling>
                    <div>
                        <div className="margin-bottom-30">
                            <button id="ownVehicle-tab"
                                className="w3-blue w3-round w3-hover-blue"
                                name="ownVehicle" onClick={e => changeTab(e)}>Own Vehicle</button>
                            <button id="marketVehicle-tab"
                                className="w3-white w3-round w3-hover-white margin-left-20"
                                name="marketVehicle" onClick={e => changeTab(e)}>Market Vehicle</button>
                        </div>
                        <div>
                            {vehicleTypeSelected == 'ownVehicle' ?
                                <>
                                    <OwnVehiclePlanning auth={auth} props={props}></OwnVehiclePlanning>
                                </>
                                :
                                <>
                                    <MarketVehiclePlanning auth={auth} props={props}></MarketVehiclePlanning>
                                </>
                            }
                        </div>
                    </div>
                </Modal.Content>
            </Modal>
        </div>
    );
};


export default ModalPlanningDetails;